import {
  ArrowDownUp,
  Backpack,
  CalendarCheck,
  ClipboardCheck,
  Compass,
  Download,
  Eye,
  Gift,
  Glasses,
  Hand,
  Layers,
  Library,
  ListOrdered,
  MessageSquare,
  MoveHorizontal,
  ShieldAlert,
  Target,
  TrendingUp,
  Users,
  Waves,
  Wind,
  Wrench,
  type LucideIcon,
} from 'lucide-react'

export interface IncludedFeature {
  label: string
  icon: LucideIcon
  /** Headline features get a larger, navy card */
  featured?: boolean
}

export const everythingIncluded: IncludedFeature[] = [
  { label: '6 Complete Volumes', icon: Library, featured: true },
  { label: '150 Ready-to-Teach Scuba Lessons', icon: CalendarCheck, featured: true },
  { label: '100% Visual', icon: Eye, featured: true },
  { label: 'Beginner to Advanced', icon: TrendingUp, featured: true },
  { label: 'Equipment & Foundations', icon: Backpack },
  { label: 'Buoyancy & Breathing', icon: Wind },
  { label: 'Trim & Hovering', icon: MoveHorizontal },
  { label: 'Descents & Ascents', icon: ArrowDownUp },
  { label: 'Mask & Regulator Skills', icon: Glasses },
  { label: 'Finning', icon: Waves },
  { label: 'Navigation', icon: Compass },
  { label: 'Buddy Skills', icon: Users },
  { label: 'Underwater Communication', icon: Hand },
  { label: 'Safety & Decision-Making', icon: ShieldAlert },
  { label: 'Visual Skill Breakdowns', icon: Layers },
  { label: 'Instructor Cues', icon: MessageSquare },
  { label: 'Common Errors & Corrections', icon: Wrench },
  { label: 'Assessments', icon: ClipboardCheck },
  { label: 'Skill Progressions', icon: ListOrdered },
  { label: '100 Training Drills', icon: Target },
  { label: '5 Professional Bonus Guides', icon: Gift },
  { label: 'Immediate Digital Access', icon: Download },
]
